import { defineMessages } from 'react-intl';
export const itemMessages = defineMessages({
    adresy: {
        id: 'search.adresy.item.content.html',
        defaultMessage: '<ITEM><LABEL>{typeDescCz}</LABEL><VALUE>{label}</VALUE></ITEM>',
    },
    parcely: {
        id: 'search.parcely.item.content.html',
        defaultMessage: '{label}',
    },
    coords: {
        id: 'search.coords.item.content.html',
        defaultMessage: '<ITEM><LABEL>S-JTSK</LABEL><VALUE>{x5513}, {y5513}</VALUE></ITEM><ITEM><LABEL>WGS84</LABEL><VALUE>{lat}, {lon}</VALUE></ITEM>',
    },
});
//# sourceMappingURL=messages.js.map